<div class="world-clock-container text-center border border-1">

  <h2>Digital World Clock</h2>

  <!-- Timezone Selector -->
  <div class="form-group">
    <label for="timezoneSelect">Select Time Zone</label>
    @if(timezones().length) {
        <div class="selector d-flex justify-content-center">
            <select
                id="timezoneSelect"
                class="form-control"
                (change)="onZoneChange($event)"
                >
                <option value="" disabled selected hidden>
                    Select time zone
                </option>
        
                <option
                    *ngFor="let zone of timezones()"
                    [value]="zone.id"
                    [selected]="zone.id === selectedZone()?.id"
                >
                    {{ zone.label }}
                </option>
            </select>
        </div>
    }

  <!-- Clock Display -->
  <div
    class="clock-display"
    *ngIf="selectedZone() as zone"
  >
    <div class="time">
      {{ formattedTime() }}
    </div>

    <div class="date">
      {{ formattedDate() }}
    </div>

    <div class="timezone">
      {{ zone.label }}
    </div>
  </div>

  <!-- Loading State -->
  <div
    class="loading"
    *ngIf="!timezones().length"
  >
    Loading time zones…
  </div>

</div>
